module.exports = __webpack_public_path__ + "img/four_zhCn.55599379.png";